var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send_black_24dp_1_",
    "data-name": "send_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12498",
    "data-name": "Path 12498",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "send",
    d: "M17.467.109a.619.619,0,0,1,.267.634L15.2,15.953a.623.623,0,0,1-.317.446.607.607,0,0,1-.307.079.668.668,0,0,1-.238-.049L9.852,14.6l-2.4,2.921a.583.583,0,0,1-.485.228.538.538,0,0,1-.218-.039.634.634,0,0,1-.416-.594V13.656L14.892,3.169,4.307,12.329.4,10.725A.627.627,0,0,1,.316,9.6L16.794.089A.6.6,0,0,1,17.111,0a.614.614,0,0,1,.356.109Z",
    transform: "translate(2.129 2.75)",
    fill: "#556ee6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBlack);
export default __webpack_public_path__ + "static/media/send_black.c749bcfa.svg";
export { ForwardRef as ReactComponent };